import Vue from 'vue'
import Chart from 'chart.js'

if (process.client) {
  Vue.prototype.$Chart = Chart;
}
